import { clamp } from "../lib/motion";

export const EVENING_FADE_START = 0.04;

/** Fallback for S4's pull-up over the pinned S3 stage, used only until S4's
 *  measured height arrives. The runtime value is S4's measured height exactly
 *  (use-section-four-overlap) and the runway is sized to match (see
 *  use-section-three-scroll), so the cover ends when the section ends on any
 *  viewport height — no S3 runway is left scrolling after S4 ends. */
export const SECTION_FOUR_OVERLAP_UNITS = 2.7;

/** Pinned scroll dwell before S4's edge meets the fold. The runway is sized to
 *  S4's measured height + one viewport + this dwell, so the desk's edge enters
 *  this many viewports after the stage pins on ANY viewport height (the fixed
 *  runway used to let this drift later on taller screens). The scene — content
 *  included — starts receding at the pin, then S4 follows this short beat. */
export const SECTION_THREE_MIN_PINNED_DWELL_UNITS = 0.04;

export function linkedProgress(worldProgress: number, start: number, span: number): number {
	return clamp((worldProgress - start) / span);
}
